exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".src-sp-components-organisms-Signup-___Signup__container___YReUh {\n  padding: 24px 16px;\n}\n\n.src-sp-components-organisms-Signup-___Signup__header___5snYI {\n  height: 36px;\n  margin-bottom: 32px;\n}\n\n.src-sp-components-organisms-Signup-___Signup__l-input-form___TgfCj {\n  margin-top: 30px;\n  margin-bottom: 70px;\n}\n", ""]);

// exports
exports.locals = {
	"container": "src-sp-components-organisms-Signup-___Signup__container___YReUh",
	"header": "src-sp-components-organisms-Signup-___Signup__header___5snYI",
	"l-input-form": "src-sp-components-organisms-Signup-___Signup__l-input-form___TgfCj"
};